import React from 'react';
import GenericShipmentRequest from '../GenericShipmentRequest';

const HouseKeepingShipmentRequest = () => (
  <GenericShipmentRequest
    sectionName="House Keeping"
    sectionKey="House Keeping"
    backRoute="/sections/house-keeping"
  />
);

export default HouseKeepingShipmentRequest;
